export default [
  {
    id: 1,
    device: "Device 1",
    nickname: 'asperiores',
    signalstrength: '2',
    salary: '€ 13098.00',
    age: 39
  },
  {
    id: 2,
    device: 'Device 2',
    nickname: 'alias',
    signalstrength: require("@/assets/img/signal0.png"),
    salary: '€ 35978.00',
    age: 26
  },
  {
    id: 3,
    device: 'Device 3',
    nickname: 'id',
    signalstrength: 'little.myrna@example.net',
    salary: '€ 26278.00',
    age: 48
  },
  {
    id: 4,
    device: 'Device 5',
    nickname: 'vel',
    signalstrength: 'dock47@example.org',
    salary: '€ 25537.00',
    age: 27
  },
  {
    id: 5,
    device: 'Device 6',
    nickname: 'qui',
    signalstrength: 'ugrady@example.org',
    salary: '€ 49003.00',
    age: 21
  },
  {
    id: 6,
    device: 'Ms. Crystel Zemlak IV',
    nickname: 'reiciendis',
    signalstrength: 'amari.rau@example.com',
    salary: '€ 12383.00',
    age: 48
  },
  {
    id: 7,
    device: 'Nona McDermott',
    nickname: 'quaerat',
    signalstrength: 'adrien.baumbach@example.org',
    salary: '€ 18512.00',
    age: 31
  },
  {
    id: 8,
    device: 'Miss Genoveva Murazik V',
    nickname: 'rerum',
    signalstrength: 'ohettinger@example.net',
    salary: '€ 31209.00',
    age: 28
  },
  {
    id: 9,
    device: 'Beulah Huels',
    nickname: 'non',
    signalstrength: 'stefan99@example.com',
    salary: '€ 36920.00',
    age: 53
  },
  {
    id: 10,
    device: 'Zoe Klein',
    nickname: 'ex',
    signalstrength: 'ejacobson@example.org',
    salary: '€ 35616.00',
    age: 27
  },
];
